import React from "react";

class NightAuditFolioItemsSummary extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    return(
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text" style={{marginBottom: '0px'}}>{this.props.confirmationResponse ? I18n.t("charges") : I18n.t("summary")}</h3>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <table className="table table-bordered">
                  {this.renderSummaryTableHead()}
                  {this.renderSummaryTableBody()}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSummaryTableHead() {
    return (
      <thead className="thead">
        <tr className="active">
          {
            this.props.confirmationResponse 
            ?
            <th scope="col">{I18n.t("posted")}</th>
            :
            <th scope="col">{I18n.t("items")}</th>
          }
          <th scope="col">{I18n.t("lodging")}</th>
          <th scope="col">{I18n.t("products")}</th>
          <th scope="col">{I18n.t("fees")}</th>
          <th scope="col">{I18n.t("additional_taxes")}</th>
          <th scope="col">{I18n.t("total")}</th>
        </tr>
      </thead>
    );
  };

  renderSummaryTableBody() {
    if(this.props.totals && Object.keys(this.props.totals).length) {
      return (
        <tbody>
          <tr>
            {
              this.props.confirmationResponse
              ?
              <td scope="col">{this.props.confirmationResponse.posted_folio_items.posted.length ? this.props.confirmationResponse.posted_folio_items.posted.length : 0}</td>
              :
              <td scope="col">{this.calculateItemCountTotal()}</td>
            }
            <td>{this.props.formatCurrency(this.props.totals.lodging)}</td>
            <td>{this.props.formatCurrency(this.calculateProductTotal())}</td>
            <td>{this.props.formatCurrency(this.props.totals.fees)}</td>
            <td>{this.props.formatCurrency(this.props.totals.taxes)}</td>
            <td>{this.props.formatCurrency(this.calculateTotal())}</td>
          </tr>
        </tbody>
      );
    };
  };

  calculateProductTotal() {
    return (this.props.totals && this.props.totals.products ? Object.keys(this.props.totals.products).reduce((acc, key) => {
      if (!key.includes('_count')) {
        acc += this.props.totals.products[key]
      }
      return acc
      }, 0) : null)
    };

  calculateProductCount() {
    return ( this.props.totals && this.props.totals.products ? Object.keys(this.props.totals.products).reduce((acc, key) => {
      if (key.includes('_count')) {
        acc += this.props.totals.products[key]
      }
      return acc 
      }, 0) : null)
    };

  calculateTotal() {
    return(Object.keys(this.props.totals).reduce((acc, key) => {
      if (!key.includes('_count') && key != 'payments' && key != 'deposits' && key != 'cc_auths'){
        if (key === "products") {
          acc += this.calculateProductTotal()
        } else {
          acc += this.props.totals[key]
        };
      };
      return acc
    }, 0))
  };
  
  calculateItemCountTotal() {
    return(Object.keys(this.props.totals).reduce((acc, key) => {
      if (key.includes('_count') && key != 'deposits_count' && key != 'payments_count' && key != 'id_auths_count' && key != 'check_in_auths_count' && key != 'no_shows_count' || key === 'products'){
        if (key === "products") {
          acc += this.calculateProductCount()
        } else {
          acc += this.props.totals[key]
        };
      };
      return acc
    }, 0))
  };
};

export default NightAuditFolioItemsSummary